import React, {useEffect, useState} from 'react';
import Container from "../../components/UI/Container/Container";
import Block from "../../components/UI/Block/Block";
import {
  Alert,
  Button,
  Col,
  Divider, Flex,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Space, Statistic,
  Table,
  Typography
} from "antd";
import {API} from "../../http";
import {NEW_ENDPOINTS} from "../../http/endpoints";
import {useColumnSearchProps} from "../../hooks/useColumnSearchProps";
import moment from "moment";
import {ExclamationCircleFilled} from "@ant-design/icons";
import classes from './DayClose.module.scss';
import CloseDayModal from "../../components/CloseDayModal/CloseDayModal";

const DayClose = () => {
  const [loading, setLoading] = useState(false);
  const [closeHistory, setCloseHistory] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const {getColumnSearchProps} = useColumnSearchProps();

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 200,
      ...getColumnSearchProps('id', (_, record) => <Typography.Text copyable={record?.id}
                                                                    ellipsis={{tooltip: record?.id}}>{record?.id || '-/-'}</Typography.Text>),
    },
    {
      title: 'balance_users',
      dataIndex: 'balance_users',
      key: 'balance_users',
      width: 150,
      render: (value) => <Typography.Text>{value || '-/-'}</Typography.Text>
    },
    {
      title: 'balance_tesla',
      dataIndex: 'balance_tesla',
      key: 'balance_tesla',
      width: 150,
      render: (value) => <Typography.Text>{value || '-/-'}</Typography.Text>
    },
    {
      title: 'balance_safeguard',
      dataIndex: 'balance_safeguard',
      key: 'balance_safeguard',
      width: 160,
      render: (value) => <Typography.Text>{value || '-/-'}</Typography.Text>
    },
    {
      title: 'balance_operational',
      dataIndex: 'balance_operational',
      key: 'balance_operational',
      width: 170,
      render: (value) => <Typography.Text>{value || '-/-'}</Typography.Text>
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      fixed: 'right',
      width: 180,
      render: (value) => <Typography.Text
        ellipsis>{moment(value).format('DD.MM.YYYY, HH:mm:ss')}</Typography.Text>,
      defaultSortOrder: 'descend',
      sorter: (a, b) => {
        const dateA = moment(a.createdAt).toDate();
        const dateB = moment(b.createdAt).toDate();
        if (dateA < dateB) {
          return -1;
        } else if (dateA > dateB) {
          return 1;
        } else {
          return 0;
        }
      },
    },
  ];
  const fetchHistory = async () => {
    setLoading(true);
    try {
      const {data} = await API.get(NEW_ENDPOINTS.ADMIN.CLOSE_DAY.GET_HISTORY);
      setCloseHistory(data);
    } catch (e) {
      message.error('Failed to get operations history');
      setCloseHistory([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchHistory();
  }, []);

  return (
    <Container>
      <Block>
        <Flex justify="center">
          <Button style={{ maxWidth: 300 }} shape="round" size="large" type="primary" onClick={() => setIsModalVisible(true)} block danger>
            Close day
          </Button>
        </Flex>

        <Divider/>

        <Typography.Title level={4}>Previous operations:</Typography.Title>
        <Table rowKey="id" locale={{emptyText: 'No transactions found'}} scroll={{x: 1010}} loading={loading}
               columns={columns} dataSource={closeHistory || []} showSorterTooltip={false}
               pagination={{position: ['none', 'bottomCenter'], hideOnSinglePage: true}}/>
      </Block>

      <CloseDayModal open={isModalVisible} onClose={() => setIsModalVisible(false)}/>
    </Container>
  );
};

export default DayClose;
